import { render, staticRenderFns } from "./variableManage.vue?vue&type=template&id=3674423f&scoped=true"
import script from "./variableManage.vue?vue&type=script&lang=js"
export * from "./variableManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3674423f",
  null
  
)

export default component.exports